;(() => {
  const megaMenu = document.querySelector('nav.mega-menu')
  const dropdowns = megaMenu.querySelector('.dropdowns')
  let hoverTimeout

  megaMenu.querySelectorAll('.top-level a').forEach((a) => {
    const dropdown = document.getElementById(a.dataset.open)
    if (!dropdown) return

    a.addEventListener('mouseenter', () => {
      clearTimeout(hoverTimeout)
      hoverTimeout = setTimeout(() => dropdown.classList.add('active'), 250)
    })

    a.addEventListener('mouseleave', (e) => {
      clearTimeout(hoverTimeout)
      if (!e.relatedTarget.closest('.dropdowns'))
        dropdown.classList.remove('active')
    })
  })

  dropdowns.addEventListener('mouseleave', () =>
    megaMenu.querySelector('.dropdown.active')?.classList.remove('active')
  )
})()
